var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "panel",
    {
      staticClass: "csv-export",
      attrs: { "panel-title": _vm.$t("panelTitle"), "is-loading": false },
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c("alert", {
            staticClass: "positioned-alert",
            attrs: {
              icon: ["fas", "info"],
              type: "info",
              title: _vm.$t("noDataError.title"),
              message: _vm.$t("noDataError.message"),
              show: _vm.noData && !_vm.isLoading,
              closeable: false,
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "opn-spinner",
            class: { shown: _vm.isLoading },
          }),
          _vm._v(" "),
          !_vm.isLoading && !_vm.noData
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.d200.bottom.html",
                      modifiers: {
                        hover: true,
                        d200: true,
                        bottom: true,
                        html: true,
                      },
                    },
                  ],
                  staticClass: "number-of-feedbacks badge-light",
                  attrs: { title: _vm.checkDataTitle },
                },
                [
                  _vm.form.type === "feedbacks"
                    ? _c(
                        "div",
                        { staticClass: "feedbacks" },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("groupedNumber")(
                                  _vm.checkData.numberOfFeedbacks
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("font-awesome", {
                            staticClass: "font-awesome",
                            attrs: { icon: ["fas", "user"] },
                          }),
                        ],
                        1
                      )
                    : _vm.form.type === "reasons"
                    ? _c(
                        "div",
                        { staticClass: "rating-reasons" },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("groupedNumber")(
                                  _vm.checkData.numberOfRatingReasons
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("font-awesome", {
                            staticClass: "font-awesome",
                            attrs: { icon: ["fas", "tasks"] },
                          }),
                        ],
                        1
                      )
                    : _vm.form.type === "matrix"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "feedbacks" },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("groupedNumber")(
                                    _vm.checkData.numberOfFeedbacks
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("font-awesome", {
                              staticClass: "font-awesome",
                              attrs: { icon: ["fas", "user"] },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feedbacks" },
                          [
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("groupedNumber")(
                                    _vm.checkData.numberOfLocationsWithData
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("font-awesome", {
                              staticClass: "font-awesome",
                              attrs: { icon: ["fas", "map-marker-alt"] },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { sm: "5", xl: "3" } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "radio-type" },
                      },
                      [_vm._v(_vm._s(_vm.$t("label.type")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "7", xl: "9" } },
                    [
                      _c(
                        "b-form-radio-group",
                        {
                          attrs: { id: "radio-type" },
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        [
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "radiobox-blue",
                              attrs: { value: "feedbacks" },
                            },
                            [_vm._v(_vm._s(_vm.$t("option.feedbacks")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "radiobox-blue",
                              attrs: { value: "reasons" },
                            },
                            [_vm._v(_vm._s(_vm.$t("option.reasons")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "radiobox-blue",
                              attrs: { value: "matrix" },
                            },
                            [_vm._v(_vm._s(_vm.$t("option.matrix")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.type === "matrix"
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c("b-col", { attrs: { sm: "5", xl: "3" } }, [
                        _c(
                          "label",
                          {
                            staticClass: "form-label",
                            attrs: {
                              for: "checkbox-matrixExportAggregateByLocationGroup",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("label.aggregateByLocationGroup"))
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "7", xl: "9" } },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "checkbox-matrixExportAggregateByLocationGroup",
                            },
                            model: {
                              value:
                                _vm.form.matrixExportAggregateByLocationGroup,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "matrixExportAggregateByLocationGroup",
                                  $$v
                                )
                              },
                              expression:
                                "form.matrixExportAggregateByLocationGroup",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { sm: "5", xl: "3" } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "input-date-range" },
                      },
                      [_vm._v(_vm._s(_vm.$t("label.dateRange")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { sm: "7", xl: "9" } }, [
                    _c(
                      "div",
                      [
                        _c("opn-date-range-picker", {
                          attrs: {
                            value: this.form.dateRange,
                            id: "input-date-range",
                            "is-loading": false,
                            "is-in-form": true,
                            "with-limited-ranges": true,
                          },
                          on: { "change-daterange": _vm.dateRangeChanged },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { sm: "5", xl: "3" } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "input-locations" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("label.locations")) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.d200",
                                modifiers: { hover: true, d200: true },
                              },
                            ],
                            staticClass: "info-circle-wrapper",
                            attrs: { title: _vm.$t("tooltip.locations") },
                          },
                          [
                            _c("font-awesome", {
                              staticClass: "info-circle",
                              attrs: { icon: ["far", "info-circle"] },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { id: "location-flex", sm: "7", xl: "9" } },
                    [
                      _c("location-group-select", {
                        attrs: {
                          id: "input-locations",
                          "is-loading": false,
                          limit: 999,
                          "is-in-form": true,
                          "pre-selected-ids": _vm.filter.location,
                        },
                        on: { "change-locations": _vm.changeLocations },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "filter-selector" } },
                        [
                          !_vm.currentUserIsSuperAdmin
                            ? _c("search-filter-selector", {
                                attrs: {
                                  "is-loading": false,
                                  "pre-selected-search-filter-id":
                                    _vm.filter.location.selectedSearchFilterId,
                                },
                                on: { "change-locations": _vm.changeLocations },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { sm: "5", xl: "3" } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "select-language" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("label.language")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { sm: "7", xl: "9" } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "b-form-select",
                          {
                            attrs: { id: "select-language" },
                            model: {
                              value: _vm.language,
                              callback: function ($$v) {
                                _vm.language = $$v
                              },
                              expression: "language",
                            },
                          },
                          _vm._l(
                            _vm.allowedLanguages,
                            function (allowedLanguage) {
                              return _c(
                                "option",
                                {
                                  key: allowedLanguage,
                                  domProps: { value: allowedLanguage },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "languages." +
                                            allowedLanguage.toLowerCase()
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { sm: "5", xl: "3" } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "radio-charset" },
                      },
                      [_vm._v(_vm._s(_vm.$t("label.charset")))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "7", xl: "9" } },
                    [
                      _c(
                        "b-form-radio-group",
                        {
                          attrs: { id: "radio-charset" },
                          model: {
                            value: _vm.charset,
                            callback: function ($$v) {
                              _vm.charset = $$v
                            },
                            expression: "charset",
                          },
                        },
                        [
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "radiobox-blue",
                              attrs: { value: "utf8" },
                            },
                            [_vm._v(_vm._s(_vm.$t("option.utf8")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "radiobox-blue",
                              attrs: { value: "excel" },
                            },
                            [_vm._v(_vm._s(_vm.$t("option.excel")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("b-container", { attrs: { fluid: "" } }, [
            _vm.isLoading || _vm.noData
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-primary float-right disabled",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("font-awesome", {
                      attrs: { icon: ["fas", "cloud-download-alt"] },
                    }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("exportButton")) + "\n      "
                    ),
                  ],
                  1
                )
              : _c(
                  "a",
                  {
                    staticClass: "btn btn-primary float-right",
                    attrs: { href: _vm.requestUrl, target: "_blank" },
                  },
                  [
                    _c("font-awesome", {
                      attrs: { icon: ["fas", "cloud-download-alt"] },
                    }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("exportButton")) + "\n      "
                    ),
                  ],
                  1
                ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }